module.exports = __webpack_public_path__ + "img/FR16807.51ccee64.png";